import React from 'react';
import { Button } from '@mui/material';

function HorasButtons({ recurso, classes, handleData }) {
  const qtd = Number(recurso.qtd) || 0;
  return (
    <div style={{ marginLeft: '20px' }}>
      {qtd <= 0 ? null : (
        <Button
          color="primary"
          size="sm"
          onClick={() => {
            handleData(qtd - 1);
          }}
          className={classes.buttons}
          disabled={recurso && (recurso.validadoCD || recurso.validadoAD || recurso.validadoRH)}
        >
          -
        </Button>
      )}
      {qtd >= 24 ? (
        <Button className={classes.buttons} color="primary" size="sm" disabled>
          +
        </Button>
      ) : (
        <Button
          className={classes.buttons}
          color="primary"
          size="sm"
          onClick={() => {
            handleData(qtd + 1);
          }}
          disabled={recurso && (recurso.validadoCD || recurso.validadoAD || recurso.validadoRH)}
        >
          +
        </Button>
      )}
      {qtd > 20 ? (
        <Button className={classes.buttons} color="primary" size="sm" disabled>
          +4h
        </Button>
      ) : (
        <Button
          className={classes.buttons}
          color="primary"
          size="sm"
          onClick={() => {
            handleData(qtd + 4);
          }}
          disabled={recurso && (recurso.validadoCD || recurso.validadoAD || recurso.validadoRH)}
        >
          +4h
        </Button>
      )}
      {qtd > 16 ? (
        <Button className={classes.buttons} color="primary" size="sm" disabled>
          +8h
        </Button>
      ) : (
        <Button
          className={classes.buttons}
          color="primary"
          size="sm"
          onClick={() => {
            handleData(qtd + 8);
          }}
          disabled={recurso && (recurso.validadoCD || recurso.validadoAD || recurso.validadoRH)}
        >
          +8h
        </Button>
      )}
    </div>
  );
}

export default HorasButtons;
